/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Loader } from "semantic-ui-react";

class UpdateLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderText1: "",
      loaderText2: "",
    };
  }

  changeLoaderText = (loaderText1, loaderText2) => {
    this.setState({ 
      loaderText1: loaderText1,
      loaderText2: loaderText2
    });
  }

  render() {
    return (
      <Loader size="huge" indeterminate>
        {this.state.loaderText1}<br />
        {this.state.loaderText2}
      </Loader>
    );
  }
}

export default UpdateLoader;
